import {Component, EventEmitter, inject} from '@angular/core';

import {ToastrService} from "ngx-toastr";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {environment} from "@numizmat/environments";
import {ImageComponent} from "@numizmat/components";
import {ForceRepaintDirective} from "@numizmat/directives";
import {ProfileImageApiService} from "@numizmat/services/core";
import {ImagProcessingService} from "@numizmat/services/common";

@Component({
  selector: 'nz-profile-image-modal',
  imports: [
    ImageComponent,
    ForceRepaintDirective
  ],
  templateUrl: './profile-image-modal.component.html',
  styleUrl: './profile-image-modal.component.scss'
})
export class ProfileImageModalComponent {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private toastrService: ToastrService = inject(ToastrService);
  private imagProcessingService: ImagProcessingService = inject(ImagProcessingService);
  private profileImageApiService: ProfileImageApiService = inject(ProfileImageApiService);

  protected loading: boolean = false;
  protected canSubmit: boolean = false;
  protected profileImageUrl: string | null = null;
  protected selectedFile: File | null = null;
  protected userProfileImageIdChange: EventEmitter<string | null> = new EventEmitter<string | null>();

  protected readonly environment = environment;

  protected onSubmit(): void {
    if (!this.canSubmit) {
      return;
    }
    this.loading = true;
    if (!!this.selectedFile) {
      this.imagProcessingService.resizeImage(this.selectedFile, 400).then((image) => {
        const request: FormData = new FormData();
        request.append('image', image);
        this.profileImageApiService.upsertProfileImage(request).subscribe({
          next: response => {
            this.loading = false;
            this.userProfileImageIdChange.emit(response);
            this.toastrService.success("Успешно редактирахте профилната си снимка.");
            this.closeModal();
          }
        });
      });
    } else {
      this.profileImageApiService.deleteProfileImage().subscribe({
        next: response => {
          this.loading = false;
          this.userProfileImageIdChange.emit(null);
          this.toastrService.success("Успешно премахнахте профилната си снимка.");
          this.closeModal();
        }
      });
    }
  }

  protected async onSelectImage(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files: File[] = Array.from(input.files);
      this.selectedFile = files[0];
      const previews: string[] = await this.imagProcessingService.generatePreviewUrls(files);
      this.profileImageUrl = previews[0];
    }
    input.value = '';
    this.canSubmit = true;
  }

  protected onDeleteImage(): void {
    this.canSubmit = true;
    this.selectedFile = null;
    this.profileImageUrl = null;
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }
}
